// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"3a2c17c9","541":"5b70dc93","779":"a0b5fae5","951":"aaf202bd"}[chunkId] + ".chunk.css";
};